import utils from './wallUtils';

// LOGINWALL JS FROM LONDO
const CALLBACK_MAX_WAIT = 3000;
const CALLBACK_EVENT_TIMEOUT = 2000;
const CALLBACK_DELAY = 300;

const trackLoginPaywallEvent = (action, cb) => {
  if (window.LorienDispatch) {
    const payload = {
      structuredEvent: {
        eventCategory: 'Funnel Tracking',
        eventAction: action,
      },
    };
    if (typeof cb === 'function') {
      // Never wait longer than CALLBACK_MAX_WAIT
      setTimeout(() => {
        cb();
      }, CALLBACK_MAX_WAIT);
      payload.eventTimeout = CALLBACK_EVENT_TIMEOUT;
      payload.eventCallback = cb;
    }
    window.LorienDispatch.dispatchEvent('loginWallEvent', payload);
  } else if (typeof cb === 'function') {
    cb();
  }
};

const trackLoginWallClick = (elem, action) => {
  elem.addEventListener('click', (event) => {
    event.preventDefault();
    const url = event.currentTarget.href;
    const callbackToRedirectUser = () => {
      setTimeout(() => {
        window.location.href = url;
      }, CALLBACK_DELAY);
    };
    trackLoginPaywallEvent(action, callbackToRedirectUser);
  });
};

const applyParamsToUrl = (href, params) =>
  Object.entries(params).reduce((acc, [key, value]) => utils.setUrlParameter(acc, key, value), href);

const loginRequiredPaywall = (options) => {
  const trxId = utils.generateTransactionId();
  const pwCreateLink = document.querySelector('.js-create-account-link');
  const pwLoginLink = document.querySelector('.js-login-link');
  const createParams = utils.getLoginwallUrlParams(options.channel, 'login-paywall-signup', trxId);
  if (pwCreateLink.href.includes('luotunnus')) {
    pwCreateLink.href = applyParamsToUrl(pwCreateLink.href, createParams);
  } else {
    const { next, ...rest } = createParams;
    pwCreateLink.href = applyParamsToUrl(pwCreateLink.href, {
      ...rest,
      content_url: window.location.origin + next,
    });
  }
  pwLoginLink.href = applyParamsToUrl(
    pwLoginLink.href,
    utils.getLoginwallUrlParams(options.channel, 'login-paywall-logins', trxId),
  );

  window.dataLayer.push({
    logintxid: trxId,
  });

  trackLoginPaywallEvent('Login Walled Page Landed');
  trackLoginWallClick(pwCreateLink, 'Signup link clicked');
  trackLoginWallClick(pwLoginLink, 'Login link clicked');
};

export default loginRequiredPaywall;
